import { c as _c } from "react/compiler-runtime";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { RateMatter } from "@/types/enums";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import UserPageRateWrapper from "../../utils/rate/UserPageRateWrapper";
import UserPageRepNewRep from "./UserPageRepNewRep";
export default function GrantRepDialog(t0) {
  const $ = _c(11);
  const {
    profile,
    overview,
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose || $[1] !== overview || $[2] !== profile) {
    t1 = <UserPageRepNewRep profile={profile} overview={overview} onSuccess={onClose} onCancel={onClose} />;
    $[0] = onClose;
    $[1] = overview;
    $[2] = profile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== profile || $[5] !== t1) {
    t2 = <UserPageRateWrapper profile={profile} type={RateMatter.REP}>{t1}</UserPageRateWrapper>;
    $[4] = profile;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== t2) {
    t3 = <MobileWrapperDialog title="Grant Rep" isOpen={isOpen} onClose={onClose} tabletModal={true} maxWidthClass="md:tw-max-w-md">{t2}</MobileWrapperDialog>;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}